<template>
    <div :key="objectKey">

        <div class="mb-4">
            <b-form-row class="mt-2 mb-2">
                <b-col  v-if="!isMonitoringRequest" sm="12" md="3" lg="2">
                    <form-field :class="{ 'required' : getAbility('plannedCount') && !object.id && !object.isCompleted }"
                                 :label="getFieldLabel('plannedCount')"
                                 :editable="getAbility('plannedCount') && !object.id && !object.isCompleted"
                                 :value="object.plannedCount"
                                 :feedback="liveFeedback('plannedCount')">
                        <template #field>
                            <b-form-input
                                id="plannedCount"
                                class="w-100"
                                type="text"
                                v-model="$v.form.plannedCount.$model"
                                :state="validateState('plannedCount')">
                            </b-form-input>
                        </template>
                    </form-field>
                </b-col>

                <b-col sm="12" md="9" lg="6">
                    <date-time-picker
                                  title="Запланирован"
                                  name="plannedAt"
                                  :key="object.plannedAt"
                                  :editable="getAbility('plannedAt') && !object.id  && !object.isCompleted"
                                  :show-timepicker="true"
                                  :initial-date-string="getInitialDateString()"
                                  :state="validateState('plannedAt')"
                                  @date-changed="onModelDateChanged" />
                </b-col>
            </b-form-row>

            <b-form-row class="mt-2 mb-2" >
                <form-field
                        :label="getFieldLabel('address')"
                        class="col-xs-12 col-lg-10 col-xl-8"
                        :class="{ 'required': getAbility('address') && !object.isCompleted && !object.id }"
                        :editable="getAbility('address') && !object.isCompleted && !object.id"
                        :feedback="liveFeedback('address')"
                        :value="object.addressObject ? object.addressObject['human_readable_address'] : 'Не указан'">

                    <template #value>
                        <div style="max-width: 650px; height: 300px">
                            <map-box ref="map" :coordinates="selectedCoordinates" style="width: 100%; height: 300px"/>
                            <div class="clearfix p-1"></div>
                            <div class="col-12 p-0 m-0 d-flex align-items-center">
                                <div class="flex-grow-1 mr-2">{{ object.addressObject ? object.addressObject['human_readable_address'] : 'Не указан' }}</div>
                                <b-button variant="link" class="p-0" @click="onAddressFocus">
                                    <img :src="focus" width="32"/>
                                </b-button>
                            </div>
                        </div>
                    </template>

                    <template #field>
                        <map-box ref="map" :coordinates="selectedCoordinates" v-on:map-clicked="onMapClicked" style="width: 100%; height: 500px"/>
                        <div class="clearfix p-1"></div>
                        <div class="col-12 p-0 m-0 d-flex">
                            <single-select name="address"
                                           ref="address"
                                           class="flex-grow-1 mr-2"
                                           v-model="form['addressObject']"
                                           :url="getAddressUrl"
                                           :label="getFieldLabel('address')"
                                           label-key="human_readable_address"
                                           :state="getValidationClass('address')"
                                           :has-pagination="false"
                                           :initial-filters="addressInitialFilters"
                                           v-on:select-search-init="onAddressSearchStart"
                                           v-on:select-changed="onAddressChanged"
                                           v-on:select-set="onAddressSet"
                                           v-on:select-cleared="onModelObjectSingleSelectCleared" />
                            <b-button variant="link" class="p-0" @click="onAddressFocus">
                                <img :src="focus" width="32"/>
                            </b-button>
                        </div>
                    </template>
                </form-field>
            </b-form-row>
        </div>

        <b-button @click="onCreate" v-if="!object.id" variant="primary">Создать рейд</b-button>

    </div>

</template>

<script>
    import { todayStr } from "@/utils/dateFormat";
    import api from "@/api";
    import httpClient from "@/http";
    import FormField from "../../../../components/Forms/FormField";
    import DateTimePicker from "../../../../components/Forms/DateTimePicker";
    import { ObjectComponentMixin } from "@/components/Forms/ObjectComponentMixin";
    import {Raid} from "../../Raids/raid";
    import SingleSelect from "@/components/Select/SingleSelect";
    import {ACTIVITIES} from "@/store/auth/auth";
    import {MapMixin} from "@/components/Map/mapMixin";
    import MapBox from "@/components/Map/MapBox.vue";
    import EventBus from "@/bus";

    export default {
        name: "CatchingRaidDetail",
        components: {MapBox, SingleSelect, FormField, DateTimePicker },
        mixins: [ ObjectComponentMixin, MapMixin ],
        props: {
            raidData: { type: Object, default: () => { return null } },
            request: { type: null, default: null },
        },
        data() {
            return {
              isMonitoring: false
            }
        },
        computed: {
            raidId() {
                return this.raidData ? this.raidData['id'] : null
            },
            createUrl() {
                return api.raids.default.list()
            },
            isMonitoringRequest() {
              return this.isMonitoring
                // if (this.request) {
                //     return this.request.activity === ACTIVITIES.MONITORING
                // }
                // return false
            }
        },
        methods: {
            // initObject() {
            //     return new Promise((resolve) => {
            //         this.object = this.raid ? this.raid : new this.objectClass(this.initObjectParams);
            //         this.objectKey = new Date().getTime();
            //         EventBus.$emit('object-init-finished');
            //     })
            // },
            getInitialDateString() {
                return todayStr();
            },
            onCreate() {
                this.submitAction().then((response) => {
                    this.object.applyData(response.data);
                    this.objectKey = new Date().getTime();
                    this.$emit('object-created', response.data);
                })
            }
        },
        beforeMount() {
            this.objectClass = Raid;
            this.objectId = this.raidId;
            if (this.raidData) {
                this.objectData = this.raidData;
            }
            if (!this.objectId) {
                const animalsLeft = this.request.activity === ACTIVITIES.MONITORING ? 0 : this.request.animalsLeft
                this.initObjectParams = {
                    request: this.request.id,
                    address: this.request.address,
                    addressObject: this.request.addressObject,
                    lat: this.request.lat,
                    lon: this.request.lon,
                    requestContractorId: this.request.assignedToId,
                    plannedCount: animalsLeft
                };
                this.isMonitoring = this.request.activity === ACTIVITIES.MONITORING
            } else {
              if (this.objectData['request_object']) {
                this.isMonitoring = this.objectData['request_object']['activity'] === ACTIVITIES.MONITORING
              }
            }
        },
        mounted() {
            const vm = this;
            vm.onMount();
            vm.resetForm().then(() => {
                if (vm.objectId) {
                    if (vm.object.addressObject['id']) {
                        vm.selectedMunicipality = vm.object.addressObject['municipality_object']
                        vm.setMapCoordinates(vm.object.coordinates)
                    }
                } else {
                    if (vm.request.addressObject['id']) {
                        vm.selectedMunicipality = vm.request.addressObject['municipality_object']
                        vm.setMapCoordinates(vm.request.coordinates)
                    }
                }

            });
        },
        // beforeMount() {
        //     this.objectClass = Raid;
        //     this.objectId = this.raid ? this.raid.id : null;
        //     this.objectData = this.raidData ? this.raidData: null;
        //     if (this.request) {
        //         this.initObjectParams = { request: this.request };
        //     }
        // },
        // mounted() {
        //     const vm = this;
        //     vm.onMount();
        //     vm.resetForm().then(() => {
        //         if (this.objectId) {
        //             if (vm.object.addressObject['id']) {
        //                 vm.setMapCoordinates(vm.object.coordinates)
        //             } else if (vm.object.request.addressObject['id']) {
        //                 vm.setMapCoordinates(vm.object.request.coordinates)
        //             }
        //         } else {
        //             if (vm.request.addressObject['id']) {
        //                 vm.setMapCoordinates(vm.request.coordinates)
        //             } else if (vm.request.addressObject['id']) {
        //                 vm.setMapCoordinates(vm.request.coordinates)
        //             }
        //         }
        //     });
        // },
    }
</script>

<style scoped>

</style>